import { general } from './general';
import { text } from './text';
import { telephone } from './telephone';
import { location } from './location';
import { textarea } from './textarea';
import { name } from './name';
import { notapplicable } from './notapplicable';

export const treatment = (data = {}) => general('psychological.treatment', {
  Name: text(data?.Name),
  Phone: telephone(data?.Phone),
  Address: location(data?.Address),
  Comments: textarea(data?.Comments),
  HealthCareProviderFullName: name(data?.HealthCareProviderFullName), // pvq only
  HealthCareProviderFullNameNotApplicable: notapplicable(data?.HealthCareProviderFullNameNotApplicable), // pvq only
});
